import type { MegaMenuHeaderDesignTokens } from "@multi-tenant-cms/types/menu";

const OPTIONAL_COLOR_VARS: ReadonlyArray<{
	key: keyof MegaMenuHeaderDesignTokens;
	cssVar: string;
}> = [
	{ key: "navActiveTextColor", cssVar: "--mmh-nav-active-text" },
	{ key: "navInactiveOpenTextColor", cssVar: "--mmh-nav-inactive-open-text" },
	{ key: "categoryColor", cssVar: "--mmh-category-color" },
	{ key: "categoryHoverColor", cssVar: "--mmh-category-hover" },
	{ key: "linkColor", cssVar: "--mmh-link-color" },
	{ key: "linkDescriptionColor", cssVar: "--mmh-link-description" },
	{ key: "linkHoverColor", cssVar: "--mmh-link-hover" },
	{ key: "linkHoverBackground", cssVar: "--mmh-link-hover-bg" },
	{ key: "footerLabelColor", cssVar: "--mmh-footer-label" },
	{ key: "footerPillTextColor", cssVar: "--mmh-footer-pill-text" },
	{ key: "footerPillBackground", cssVar: "--mmh-footer-pill-bg" },
	{ key: "footerPillBorderColor", cssVar: "--mmh-footer-pill-border" },
	{ key: "footerPillHoverBackground", cssVar: "--mmh-footer-pill-hover-bg" },
	{ key: "footerPillHoverTextColor", cssVar: "--mmh-footer-pill-hover-text" },
	{ key: "ctaBackground", cssVar: "--mmh-cta-bg" },
	{ key: "ctaTextColor", cssVar: "--mmh-cta-text" },
	{ key: "ctaHoverBackground", cssVar: "--mmh-cta-hover-bg" },
	{ key: "audienceToggleBorderColor", cssVar: "--mmh-audience-border" },
	{
		key: "audienceToggleActiveBackground",
		cssVar: "--mmh-audience-active-bg",
	},
	{
		key: "audienceToggleActiveTextColor",
		cssVar: "--mmh-audience-active-text",
	},
	{
		key: "audienceToggleInactiveBackground",
		cssVar: "--mmh-audience-inactive-bg",
	},
	{
		key: "audienceToggleInactiveTextColor",
		cssVar: "--mmh-audience-inactive-text",
	},
	{
		key: "audienceToggleInactiveHoverBackground",
		cssVar: "--mmh-audience-inactive-hover-bg",
	},
];

/** Apply mega menu design colors as CSS custom properties on the header root. */
export function applyMegaMenuDesignCssVars(
	root: HTMLElement,
	design: MegaMenuHeaderDesignTokens
): void {
	root.style.setProperty("--mmh-bubble-bg", design.bubbleBackground);
	root.style.setProperty("--mmh-pill-color", design.pillColor);
	root.style.setProperty("--mmh-text-color", design.textColor);

	for (const { key, cssVar } of OPTIONAL_COLOR_VARS) {
		const value = design[key];
		if (typeof value === "string" && value.trim().length > 0) {
			root.style.setProperty(cssVar, value.trim());
		} else {
			root.style.removeProperty(cssVar);
		}
	}
}
